import { forwardRef } from "react"
import moment from "moment"

// ATALLA-384: dokumen cetak credit/debit note (dipakai react-to-print dari list.jsx).
// Ukuran mengikuti pola print PO (A4, margin standar), konten setengah halaman.

const formatRupiah = (value) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 })
    .format(Number(value || 0))

// 150726 (ATALLA-395): printedBy = user yang login saat mencetak (dikirim dari list.jsx).
const CustomerNotePrintDocument = forwardRef(({ note, outletName, printedBy }, ref) => {
  if (!note) return null

  const isCredit = String(note.type || "").toUpperCase() === "CREDIT"
  const title = isCredit ? "CREDIT NOTE" : "DEBIT NOTE"

  return (
    <div ref={ref} className="hidden print:block p-3 text-sm text-black">
      {/* 220726: kompak agar muat di kertas 9.5x11 skala 140% — margin & padding
          dikecilkan, ruang tanda tangan dipendekkan. */}
      <style>{`@page { size: A4; margin: 8mm 10mm; }`}</style>

      <div className="flex items-start justify-between border-b-2 border-black pb-2">
        <div>
          <div className="text-lg font-bold">{title}</div>
          <div className="text-xs">No: {note.note_number || "-"}</div>
        </div>
        <div className="text-right text-xs">
          <div className="font-semibold">{outletName || `Outlet ${note.outlet_id ?? "-"}`}</div>
          <div>Tanggal Terbit: {note.issue_date ? moment(note.issue_date).format("DD MMMM YYYY") : "-"}</div>
          {isCredit && note.expiry_date ? (
            <div>Berlaku s.d.: {moment(note.expiry_date).format("DD MMMM YYYY")}</div>
          ) : null}
        </div>
      </div>

      <table className="w-full mt-3 text-sm">
        <tbody>
          <tr>
            <td className="py-0.5 w-40 align-top">Customer</td>
            <td className="py-0.5 w-3 align-top">:</td>
            <td className="py-0.5 align-top font-medium">
              {note.customer_name || note.customer_id || "-"}
              {note.customer_phone ? ` (${note.customer_phone})` : ""}
            </td>
          </tr>
          <tr>
            <td className="py-0.5 align-top">Nominal</td>
            <td className="py-0.5 align-top">:</td>
            <td className="py-0.5 align-top font-bold">{formatRupiah(note.original_amount)}</td>
          </tr>
          {/* 230726 (permintaan user): baris Sisa Saldo, Status & Sumber dihapus dari cetakan. */}
          {isCredit ? (
            <tr>
              <td className="py-0.5 align-top">Uang Berasal Dari</td>
              <td className="py-0.5 align-top">:</td>
              <td className="py-0.5 align-top">
                {String(note.payment_method_type || "").toUpperCase() === "TRANSFER" ? "Transfer" :
                  String(note.payment_method_type || "").toUpperCase() === "CASH" ? "Cash" : "-"}
              </td>
            </tr>
          ) : null}
          {note.description ? (
            <tr>
              <td className="py-0.5 align-top">Keterangan</td>
              <td className="py-0.5 align-top">:</td>
              <td className="py-0.5 align-top whitespace-pre-wrap">{note.description}</td>
            </tr>
          ) : null}
        </tbody>
      </table>

      {/* 150726 (ATALLA-410): blok "Dicetak Oleh" (satu-satunya tanda tangan setelah ATALLA-395) dipindah ke tengah. */}
      {/* 200726: khusus CREDIT note ditambah kolom tanda tangan "Diketahui" (kosong, diisi basah). */}
      <div className="flex justify-center gap-10 text-center text-xs mt-14">
        {isCredit && (
          <div className="w-56">
            <div>Diketahui,</div>
            <div className="mt-16 border-t border-black pt-1">&nbsp;</div>
          </div>
        )}
        <div className="w-56">
          {/* 230726 (permintaan user): "Dicetak Oleh" (user login saat cetak, ATALLA-395)
              diganti kembali jadi "Dibuat Oleh" = pembuat DATA note (created_by). */}
          <div>Dibuat Oleh,</div>
          <div className="mt-16 border-t border-black">{note?.created_by || printedBy || " "}</div>
        </div>
        {/* 150726 (ATALLA-395): bagian "Disetujui Oleh" dihapus; label "Dibuat Oleh" diganti "Dicetak Oleh" berisi user login saat cetak. */}
      </div>
    </div>
  )
})

export default CustomerNotePrintDocument
